import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollManager from "./ScrollManager";

/** Shell shared by every marketing route. */
export function SiteLayout() {
  const { t } = useTranslation();
  return (
    <>
      <ScrollManager />
      <a href="#main" className="visually-hidden">
        {t("common.skipToContent")}
      </a>
      <Navbar />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default SiteLayout;
